import { ICarrier } from "../../interfaces/configuration";

export interface AutoCompleteStrategy {
  normalizeValue(value: ICarrier | ICarrier[] | null): ICarrier[] | null;
  getAddedCarrier(
    normalizedValue: ICarrier[] | null,
    addedOption?: ICarrier
  ): ICarrier[] | undefined;
}

export class SingleCarrierStrategy implements AutoCompleteStrategy {
  normalizeValue(value: ICarrier | ICarrier[] | null): ICarrier[] | null {
    if (!value) return null;
    return Array.isArray(value) ? value : [value as ICarrier];
  }

  getAddedCarrier(
    normalizedValue?: ICarrier[] | null,
    addedOption?: ICarrier
  ): ICarrier[] | undefined {
    if (!addedOption) return undefined;
    return [this.enableCarrier(addedOption)];
  }

  private enableCarrier(carrier: ICarrier): ICarrier {
    return { ...carrier, disabled: false };
  }
}

export class MultipleCarrierStrategy implements AutoCompleteStrategy {
  normalizeValue(value: ICarrier | ICarrier[] | null): ICarrier[] | null {
    if (!value) return null;
    return Array.isArray(value) ? value : [value];
  }

  getAddedCarrier(normalizedValue: ICarrier[] | null): ICarrier[] | undefined {
    if (!normalizedValue || normalizedValue.length === 0) return undefined;
    return normalizedValue.map(this.enableCarrier);
  }

  private enableCarrier(carrier: ICarrier): ICarrier {
    return { ...carrier, disabled: false };
  }
}

export default class AutoCompleteStrategyFactory {
  static getStrategy(isSingleMode: boolean): AutoCompleteStrategy {
    return isSingleMode
      ? new SingleCarrierStrategy()
      : new MultipleCarrierStrategy();
  }
}
